<template>
  <section
    class="component-bc463569"
    resmed-component-name="info_30/70_icon-line_list_video_2cta"
    v-bind:style="{
      'background-image': `url(${acf.layout['background-image']})`,
      'background-color': `${acf.layout['background-color']}`,
      'background-size': `${acf.layout['background-size']}`,
    }"
  >
    <div class="component">
      <div class="container px-xs-sm-2">
        <div class="row">
          <div class="col-lg-5 mb-7 mb-lg-0">
            <div class="embed-responsive embed-responsive-16by9">
              <template v-if="acf.aprimo_url">
                <video
                  class="embed-responsive-item video-js vjs-default-skin"
                  controls
                  preload="auto"
                  :data-setup="{}"
                  style="position: absolute; top:0; right:0; bottom:0; left:0; width:100%; height:100%;"
                >
                  <source :src="acf.aprimo_url" type="application/x-mpegURL" />
                </video>
              </template>
              <template v-else>
                <iframe
                  class="embed-responsive-item"
                  v-bind:src="`//players.brightcove.net/2750693505001/${acf.brightcove.player}_default/index.html?videoId=${acf.brightcove.id}`"
                  allowfullscreen
                  webkitallowfullscreen
                  mozallowfullscreen
                  frameborder="0"
                  allow="encrypted-media"
                  style="
                    position: absolute;
                    top: 0px;
                    right: 0px;
                    bottom: 0px;
                    left: 0px;
                    width: 100%;
                    height: 100%;
                  "
                ></iframe>
              </template>
            </div>
          </div>
          <div class="col-lg-7 pt-lg-3 pl-lg-5">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
            ></eyebrow-icon>
            <div class="title" v-if="acf.name">
              <h5>{{ acf.name }}</h5>
            </div>
            <h2 v-html="acf.headline"></h2>
            <ul>
              <li v-for="content in acf.content" v-html="content.item"></li>
            </ul>

            <div class="call-to-action mt-4" v-if="acf.cta[0] || acf.cta[1]">
              <a
                v-if="acf.cta[0]"
                v-bind:href="acf.cta[0].cta.href"
                v-bind:target="acf.cta[0].cta.target"
                class="
                  btn
                  cta-pill
                  filled-red
                  icon
                  right-arrow
                  mr-3
                  mb-3 mb-xl-0
                "
                >{{ acf.cta[0].cta.text }}</a
              >
              <a
                v-if="acf.cta[1]"
                v-bind:href="acf.cta[1].cta.href"
                v-bind:target="acf.cta[1].cta.target"
                class="btn cta-pill hallow-red icon right-arrow"
                >{{ acf.cta[1].cta.text }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-bc463569", // info_30/70_icon-line_list_video_2cta
  props: ["acf"],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-bc463569 {
  padding: 5rem 0;
  background-position: center center;
  background-repeat: no-repeat;
}

.component {
  h5 {
    position: relative;
    margin-bottom: 0.75rem;

    @extend %eyebrow-left;
  }

  h2 {
    margin-bottom: 2.25rem;
  }

  ul {
    padding-left: 1.125rem;
    list-style-position: outside;

    li {
      &:not(:last-child) {
        border-bottom: 1px solid rgba($cc-resmed-dark-grey, 0.25);
        margin-bottom: 1.25rem;
        padding-bottom: 1.25rem;
      }
    }
  }

  .embed-responsive {
    border-radius: 6px;
    box-shadow: -3px 0.875rem 12px 0 rgba(0, 0, 0, 0.125);
    overflow: hidden;
  }
}
</style>